import React from 'react'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import Avatar from 'Components/Avatar'
import Data from 'EurestoClass/Data'
import Utils from 'EurestoFonction/Utils'
import Color from 'color'

import moment from 'moment'
import Tooltip from '@material-ui/core/Tooltip'

moment.locale('fr')

export default (withUser = true, withDate = true) => [
  {
    Header: () => <span style={{ cursor: 'not-allowed' }}><i className="EurestoPrimary--text ei-module_crm"
      aria-hidden="true" /></span>,
    id: 'entite',
    sortable: false,
    show: withUser,
    width: 60,
    Cell: (row) => {
      return (
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%', position: 'relative' }}
          justify={'space-around'}
          alignItems={'center'} direction={'column'}>
          <Avatar
            src={row.original.media_lien}
            style={{ width: 60, height: 60, padding: 5 }} />
          {/*<span className={
            (row.original.type === Constants.access.GROUPE ? 'ei-crm_groupe ' :
              row.original.type === Constants.access.ETABLISSEMENT ? 'ei-crm_etablissement' :
                row.original.entite === 1 ? 'ei-crm_physique' : 'ei-crm_morale')}
                                                 style={{  }}/>*/}
          <i className={'EurestoPrimary--text'} style={{
            borderRadius: '50%',
            border: '1px solid black',
            position: 'absolute',
            right: '2px',
            bottom: '2px',
            fontSize: 10,
            background: Utils.reservationColor(row.original.niveau, row.original.date_reservation),
            color: row.original.niveau > 0 ? (Color(Utils.reservationColor(row.original.niveau)).isDark() ? 'white' : 'black') : 'black',
            fontWeight: 'bold' 
          }}>
            <Grid container style={{ height: 20, width: 20 }} justify={'center'}
              alignItems={'center'} alignContent={'center'} direction={'column'}><span style={{
                color: row.original.niveau >= 3 ? 'white' : 'black',
                fontWeight: 'bold',
                fontSize: 13
              }}>{row.original.quantite}</span></Grid>
          </i>
        </Grid>
      )
    },
  },
  {
    Header:
      <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
        alignItems={'center'}>
        <b>Personne/Entité</b>
      </Grid>,
    accessor: 'libelle_contact',
    show: withUser,
    Cell: row => {
      return (
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'space-around'}
          alignItems={'flex-start'} direction={'column'}>
          <b>{row.original.libelle_contact}</b>
        </Grid>
      )
    },
  },
  {
    Header: <i className={'ei-reservation_couverts'} />,
    accessor: 'quantite',
    maxWidth: 40,
    show: !withUser,
    Cell: row => {
      return (
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
          alignItems={'center'} direction={'column'}>
          <i className={'EurestoPrimary--text'} style={{
            borderRadius: '50%',
            border: '1px solid black',
            height: 25,
            width: 25,
            fontSize: 12,
            background: Utils.reservationColor(row.original.niveau, row.original.date_reservation),
            color: row.original.niveau > 0 ? (Color(Utils.reservationColor(row.original.niveau)).isDark() ? 'white' : 'black') : 'white',
            fontWeight: 'bold' 
          }}>
            <Grid container style={{ height: '100%' }} justify={'center'}
              alignItems={'center'} direction={'column'}>
              {row.original.quantite}
            </Grid>
          </i>
        </Grid>
      )
    },
  },
  {
    Header: <i className={'fa fa-clock-o EurestoPrimary--text'} />,
    minWidth: 100,
    show: withDate,
    accessor: 'date_reservation',
    Cell: row => {
      return (
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%', paddingLeft: 10 }}
          justify={'center'}
          alignItems={'flex-start'} direction={'column'}>
          <span><i
            className={'ei-reservation_calendrier_date'} />&nbsp;{moment(row.original.date_reservation).format('dddd DD MMMM YYYY HH:mm')}</span>
        </Grid>
      )
    },
  },
  {
    Header:
      <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
        alignItems={'center'}>
        <b>Email</b>
      </Grid>,
    accessor: 'email',
    show: !withDate,
    Cell: row => {
      return (
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'space-around'}
          alignItems={'flex-start'} direction={'column'}>
          <span>{row.original.email}</span>
        </Grid>
      )
    },
  },
  {
    Header:
      <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
        alignItems={'center'}>
        <b>Téléphone</b>
      </Grid>,
    accessor: 'portable',
    show: !withDate,
    Cell: row => {
      return (
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'space-around'}
          alignItems={'flex-start'} direction={'column'}>
          <span>{row.original.portable === '' ? row.original.fixe : row.original.portable}</span>
        </Grid>
      )
    },
  },
  {
    id: 'produit_id',
    Header: <i className={'fa fa-clock-o EurestoPrimary--text'} />,
    maxWidth: 100,
    Cell: row => {
      return (
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%', paddingLeft: 10 }}
          justify={'center'}
          alignItems={'flex-start'} direction={'column'}>
          <span>{(Data.get(Constants.module.RESTAURANT, Constants.donnee.produit, { id: row.original.produit_id }) || {}).libelle}</span>
          <span>{(Data.get(Constants.module.RESTAURANT, Constants.donnee.service, { id: row.original.service_id }) || {}).libelle}</span>
        </Grid>
      )
    },
  },

  {
    Header: <i className={'fa fa-flag EurestoPrimary--text'} />,
    accessor: 'reservation_pms',
    maxWidth: 100,
    Cell: row => {
      return (
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
          alignItems={'center'} direction={'column'}>
          <span>{
            row.original.reservation_pms === 1 && 'Euresto'
            || row.original.reservation_pms === 2 && 'Guestonline'
            || row.original.reservation_pms === 3 && 'Site web'
            || row.original.reservation_pms === 4 && 'Facebook'
            || row.original.reservation_pms === 5 && 'La fourchette'
            || row.original.reservation_pms === 6 && 'Externe'
            || 'web'}</span>
          {row.original.commentaire && <Tooltip disableTouchListener placement="bottom-end" title={
            <div
              style={{
                fontSize: 15,
                padding: 5,
                paddingLeft: 10,
                paddingRight: 10,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: '-moz-pre-wrap',
                //wordBreak: 'break-all',
                overflowWrap: 'break-word',
                textAlign: 'left',
                //lineHeight: '15px',
              }}>{row.original.commentaire}</div>
          }><i className={'fa fa-comment'} /></Tooltip>}
        </Grid>
      )
    },
  },
  {
    Header: 'n°',
    accessor: 'id',
    show: true,
    maxWidth: 50,
    Cell: row =>
      <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }}
        justify={'center'}
        alignItems={'center'} direction={'column'}>
        {row.original.id}
      </Grid>,
  },
  {
    Header: <i className={'fa fa-clock-o EurestoPrimary--text'} />,
    maxWidth: 40,
    accessor: 'date_creation',
    Cell: row => {
      return (
        <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%', paddingLeft: 10 }}
          justify={'center'}
          alignItems={'center'} direction={'column'}>
          <Tooltip disableTouchListener placement="bottom-end" title={
            <div
              style={{
                fontSize: 15,
                padding: 5,
                paddingLeft: 10,
                paddingRight: 10,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: '-moz-pre-wrap',
                //wordBreak: 'break-all',
                overflowWrap: 'break-word',
                textAlign: 'left',
                //lineHeight: '15px',
              }}>{moment(row.original.date_creation).format('dddd DD MMMM YYYY HH:mm')}</div>
          }><i
              className={'fa fa-plus-circle'} /></Tooltip>
        </Grid>
      )
    },
  },
  {
    Header: 'Prépaiement',
    accessor: 'prepaiement',
    show: EurestoOption(Constants.options[Constants.methods.INTERFACE].CENTRALPAY.id),
    maxWidth: 80,
    Cell: row =>
      <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%', color: EurestoColor('EurestoError'), fontWeight: 'bold' }}
        justify={'center'}
        alignItems={'center'} direction={'column'}>
        {row.original.prepaiement && (row.original.prepaiement / 100 + '€') || ''}
      </Grid>,
  },

]





// WEBPACK FOOTER //
// ./app/App/Module/Restaurant/Component/Demande/Column.js